export function record(value) {
    const r = Object.create(null);
    return (value ? Object.assign(r, value) : r);
}
//# sourceMappingURL=record.js.map